<template>
  <div id="app">
     <v-commonHead></v-commonHead>
     <router-view @tipsShow="tipsShow" />
     <v-foot @tipsShow="tipsShow"></v-foot>
    <!--加载中弹窗-->
    <div id="operationLoading"  style="display:none;">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast" style="width:146px;height:132px;">
        <img style="width:66px;height: 66px;margin:20px auto 0px;" src="@/assets/images/loading7.gif" alt="loading"/>
        <p class="weui-toast__content">努力加载中…</p>
      </div>
    </div>
    <!-- 成功提示 -->
    <div class="tips" v-show="tipsIsShow">
      <div class="mask"></div>
      <div class="detail">
        <p>{{tipsDetail}}</p>
        <a class="OKBtn"  href="javascript:;" v-on:click="closeTips">OK</a>
      </div>
    </div>
  </div>
</template>

<script>
import commonHead from '@/components/commonHead'
import foot from '@/components/foot'
export default {
  name: 'App',
  data () {
    return {
      tipsIsShow: false,
      tipsDetail: ''
    }
  },
  components: {
    'v-commonHead': commonHead,
    'v-foot': foot
  },
  methods: {
    closeTips () {
      this.tipsIsShow = false
    },
    tipsShow (message) {
      this.tipsIsShow = true
      this.tipsDetail = message
    }
  }
}
</script>

<style scoped="scoped" lang="less">
#app {
  font-family:"Microsoft YaHei",Helvetica, Arial, sans-serif;
  color: #333;
  .tips{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    z-index:101;
      .mask{
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background-color:#333;
        opacity:0.2;
        z-index:1;
      }
      .detail{
        height:150px;
        width:400px;
        background-color:#fff;
        position:absolute;
        left:50%;
        top:50%;
        margin-left:-200px;
        margin-top:-75px;
        z-index:2;
        border-radius:5px;
        text-align: center;
        p{
          font-size: 26px;
          padding: 36px 0 30px 0;
        }
        a{
          background: #f95374;
          color: #fff;
          padding:5px 18px;
          border-radius:5px;
        }
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue